module.exports = __webpack_public_path__ + "img/usepanda.com.7f3fd638.png";